import { makeStyles } from "@material-ui/core";

export const useStyles = makeStyles(() => ({
  searchFiled: {
    width: "38.25rem",
    ' .MuiInputBase-root':{ 
      height: "40px",
    }
  },
  searchIcon: {
    color: "grey",
  },
  switch: {
    marginLeft: 10,
    whiteSpace: "nowrap", // Default to nowrap for larger screens
  },
  // Media query for screens less than or equal to 1660px
  "@media (max-width: 1660px)": {
    switch: {
      whiteSpace: "normal",
    },
  },
  searchBar: {
    width: "220px",
    height: "var(--none, 1px)",
  },
  gridItemEnd: {
    display: "flex",
    justifyContent: "flex-end",
  },
}));
